export function log(message, label, level) {
  console.log(level + " [" + label + "] " + message);
}

export default { log };
